/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { TriggerEnum } from "./TriggerEnum";
import { TypeEnum } from "./TypeEnum";
import { RoleEnum } from "./RoleEnum";
export const GuidanceOptions = core.serialization.object({
    target: core.serialization.string(),
    trigger: TriggerEnum,
    type: TypeEnum,
    role: RoleEnum.optional(),
});
